import PropTypes from 'prop-types';
import moment from 'moment';

import PropTypesPresenter from '../utils/PropTypesPresenter';
import DatePresenter from '../presenters/DatePresenter';

export default new PropTypesPresenter(
  {
    fastCashId: PropTypes.string,
    userId: PropTypes.string,
    comment: PropTypes.string,
    state: PropTypes.string,
    cashbackRate: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    deletedAt: PropTypes.string,
  },
  {
    createdAtReadable(fastCash) {
      const date = moment(this.createdAt(fastCash), 'YYYY-MM-DD HH:mm:ss Z');
      return DatePresenter.dateReadable(date);
    },
    createdAtReadableItem(fastCash) {
      return DatePresenter.dateReadable(fastCash);
    },
  }
);
